import PropTypes from 'prop-types';
import { NumericFormat } from "react-number-format";

import * as Styled from './NumberInput.styles';

export const NumberInput = ({ onChange, label, value, error, className, onFocus, onBlur, type }) => {

return (
    <NumericFormat
        customInput={Styled.TextField}
        onValueChange={(value) => {
            onChange(value.floatValue)}
        }
        value={value}
        thousandSeparator=" "
        decimalSeparator=','
        decimalScale={4}
        // you can define additional custom props that are all forwarded to the customInput e. g.
        label={label}
        variant="outlined"
        error={!!error}
        helperText={error}
        onFocus={onFocus}
        onBlur={onBlur}
        className={className}
        fullWidth
    />
)};

NumberInput.propTypes = {
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  className: PropTypes.string,
};
